import { getCountryListData, getCountryListLoading } from 'redux/reducers/country/selectors';
import { useSelector } from 'react-redux';

export const useGetCountryById = (countryId: number) => {
	const countryList = useSelector(getCountryListData);
	const isLoading = useSelector(getCountryListLoading);

	// Return null for invalid country IDs
	if (!countryId || countryId <= 0) {
		return null;
	}

	if (isLoading) {
		return null;
	}

	// Check if countryList is an array (direct data) or has data property
	if (Array.isArray(countryList)) {
		const foundCountry = countryList.find((country) => country.id === countryId);
		return foundCountry;
	}

	// If countryList is not an array and not null, it's invalid data
	if (!countryList) {
		return null;
	}

	// This should never be reached, but TypeScript needs this for type safety
	return null;
};

export const useGetCountryByISOCode = (isoCode: string) => {
	const countryList = useSelector(getCountryListData);

	if (!countryList) {
		return null;
	}

	return countryList.find((country) => country.isoAlpha2 === isoCode);
};

export const useGetCountryByName = (name: string) => {
	const countryList = useSelector(getCountryListData);

	if (!countryList) {
		return null;
	}

	return countryList.find((country) => country.name === name);
};
